import { ChatPromptInput } from '~/chat/components/chat-prompt-input/ChatPromptInput';
import { Button } from '@/components/ui/button';
import { Icon } from '~/global/components/icon/Icon';
import { cn } from '@/lib/utils';
import { View } from 'react-native';

export interface ChatPromptFieldProps {
  value: string;
  onChangeText: (text: string) => void;
  onSubmit: () => void;
  /** Override the default placeholder (e.g. a context-specific prompt). */
  placeholder?: string;
  /**
   * Compact variant for the right-rail chat: a single-line white field instead
   * of the main chat's multiline surface-coloured input.
   */
  compact?: boolean;
  /** Disable input + send while the AI is thinking (prevents double-sends). */
  disabled?: boolean;
}

export const ChatPromptField = ({
  value,
  onChangeText,
  onSubmit,
  placeholder,
  compact,
  disabled,
}: ChatPromptFieldProps) => {
  return (
    <View
      className={cn(
        'flex-row items-center gap-x-3 px-4 py-3',
        // The compact rail variant drops the top divider for a cleaner panel.
        !compact && 'border-t border-border',
      )}
    >
      <ChatPromptInput
        value={value}
        onChangeText={onChangeText}
        onSubmit={onSubmit}
        placeholder={placeholder}
        multiline={!compact}
        disabled={disabled}
        inputClassName={compact ? 'bg-background border-border' : undefined}
      />
      <Button
        variant="primary"
        size="icon"
        className="h-11 w-11 rounded-full"
        textClassName="text-accent-text"
        onPress={onSubmit}
        disabled={disabled}
      >
        <Icon name="Send" />
      </Button>
    </View>
  );
};
